import { registerMutation } from 'data-fetching-client';
import deleteFormPermissions from 'ui-forms-components/api/permissions/deleteFormPermissions';
export const DELETE_FORM_PERMISSIONS_FIELD_NAME = 'deleteFormPermissions';
export const DELETE_FORM_PERMISSIONS = registerMutation({
  fieldName: DELETE_FORM_PERMISSIONS_FIELD_NAME,
  args: ['formGuids'],
  fetcher: ({
    formGuids
  }) => deleteFormPermissions(formGuids)
});